<script lang="ts" setup>
import type { IProps } from './products-imageWithBigText.types'

withDefaults(defineProps<IProps>(), {
  layout: 'default',
})

const { isMobile } = useBSBreakpoints()

</script>

<template>
  <UiSection>
    <div class="image-with-big-text">
      <UiHeader
        v-if="header"
        :header="header"
        :subheader="subheader"
        position="center"
      />

      <div
        :class="[
          'image-with-big-text__layout',
          `image-with-big-text__layout--${layout}`
        ]"
      >
        <img
          v-if="isMobile"
          class="image-with-big-text__img"
          :src="imageMobile"
        >

        <img
          v-if="!isMobile"
          class="image-with-big-text__img"
          :src="imageDesktop"
        >

        <div class="image-with-big-text__content">
          <p
            v-if="smallText"
            class="image-with-big-text__text image-with-big-text__text--small"
          >
            {{ smallText }}
          </p>

          <div
            class="image-with-big-text__text"
            v-html="text"
          />

          <p class="image-with-big-text__text image-with-big-text__text--second">
            {{ textSecond }}
          </p>

          <UiButton
            v-if="button"
            :to="button.to"
          >
            {{ button.text }}
          </UiButton>
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.image-with-big-text {
  $root: &;

  :deep() {
    .ui-header {
      @include atM {
        max-width: 109.7rem;
        margin: 0 auto;
        font-size: 4rem;
        line-height: 4.8rem;
      }
    }
  }

  &__layout {
    margin-top: 6.4rem;

    &--layout-1 {
      display: flex;
      flex-direction: column-reverse;
      margin-top: 0;
    }

    &--default {
      #{$root}__content {
        display: flex;
        flex-direction: column;

        .button {
          align-self: center;

          @include atM {
            align-self: flex-start;
          }
        }
      }
    }

    @include atM {
      display: flex;
      align-items: center;
      gap: 8.5rem;
      max-width: 115.2rem;
      margin: 12rem auto 0 auto;

      &--layout-1 {
        flex-direction: row-reverse;
        max-width: 160rem;
      }

      #{$root}__img,
      #{$root}__content {
        width: 50%;
      }
    }

    @include atXL {
      max-width: 134rem;
    }
  }

  &__img {
    width: 100%;
    margin-bottom: 2.4rem;
    border-radius: 2.4rem;

    @include atM {
      width: auto;
    }
  }

  &__text {
    font-weight: 500;
    font-size: 3.2rem;
    line-height: 4rem;

    :deep() {
      span {
        color: var(--span-color);
      }
    }

    &--second {
      margin-top: 3.2rem;
      margin-bottom: 2.4rem;
      font-weight: 500;
      font-size: 2rem;
      line-height: 2.8rem;

      @include atM {
        margin-bottom: 4.8rem;
      }
    }

    &--small {
      margin-bottom: 1.6rem;
      color: $text-200;
      font-weight: 500;
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }
}
</style>
